// Sentry (ブラウザ) の共通設定。 karte / mgmt / idp (= entrypoints/application.ts の initializeSentry) と
// navi 管理画面 (= navi/admin_area/sentry.ts) で同じ DSN・有効環境を使う。
export const SENTRY_DSN = "https://5d3e727ec0dc4e9692405ad36f598ba6@o54978.ingest.sentry.io/4504541652713472";

export function sentryEnabledFor(environment: string): boolean {
  return environment === "production" || environment === "staging" || environment === "test";
}
